import { Questionnaire } from "src/core/gql/graphql";
import { IQuestion } from "src/core/interfaces/Questionnaire";

type SchemaProperty = {
  title: string;
  type: string;
};

export const mapQuestionnaire = (questionnaire: Questionnaire) => {
  const { id, content, type } = questionnaire;
  const parsedContent = content ? JSON.parse(content) : {};
  const schema = JSON.parse(type.corpSchema);

  const questions: IQuestion[] = Object.entries(schema.properties).map(([code, value]) => {
    return {
      code,
      libelle: (value as SchemaProperty).title,
      answer: parsedContent ? parsedContent[code] : undefined,
    };
  });

  return {
    id: id,
    type: type.code,
    questions,
  };
};
